import { ModeSelectionContainer } from './modeSelection.style'

interface ModeSelectionProps {
    options: { value: string; label: string }[]
    selectedValue: string
    onChange: any
    buttonClassName?: string
    selectedButtonClassName?: string
}

export const ModeSelection: React.FC<ModeSelectionProps> = ({
    options,
    selectedValue,
    onChange,
    buttonClassName = '',
    selectedButtonClassName = '',
}: ModeSelectionProps) => {
    return (
        <ModeSelectionContainer>
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    onClick={() => onChange(option.value)}
                    className={`${buttonClassName} ${selectedValue === option.value ? selectedButtonClassName : ''}`}
                >
                    {option.label}
                </button>
            ))}
        </ModeSelectionContainer>
    )
}
